export default class Validator {
    constructor() {
        this.decimalSeparator = '.';
    }

    zipcode(value) {
        return !!(value.match(/^((0[1-9])|([1347][0-9])|(2[0-6])|(5[0-3578])|(6[0-249])|(8[0-24-689])|(9[02-8]))[0-9]{2}$/));
    }
}
